import { render, staticRenderFns } from "./addFollow.vue?vue&type=template&id=1c27e48f&scoped=true&"
import script from "./addFollow.vue?vue&type=script&lang=js&"
export * from "./addFollow.vue?vue&type=script&lang=js&"
import style0 from "./addFollow.vue?vue&type=style&index=0&id=1c27e48f&lang=less&scoped=true&"
import style1 from "./addFollow.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27e48f",
  null
  
)

export default component.exports